import { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`
  body {
    background-color: #081832;

    img {
      height: auto;
      max-width: 100%;
    }
  }
`

export default GlobalStyle
